import styled from 'styled-components';

export const StyledContent = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 40px;
`;